const BASE_URL = 'https://api.vaylens.com';
const STATION_CONNECTIVITY_TESTER_URL = '/station-connectivity-tester/api/v1';

export const environment = {
  production: true,
  int: false,
  localhost: false,
  baseUrl: BASE_URL,
  backendConnectivityTesterUrl: `${BASE_URL}${STATION_CONNECTIVITY_TESTER_URL}`,
  privacyPolicyEnUrl: 'http://vaylens.com/privacy-policy',
  privacyPolicyDeUrl: 'http://vaylens.com/de/datenschutz',
  legalNoticeEnUrl: 'http://vaylens.com/legal-notice',
  legalNoticeDeUrl: 'http://vaylens.com/de/impressum',
  termsAndConditionsEnUrl: 'http://vaylens.com/terms-and-conditions',
  termsAndConditionsDeUrl: 'http://vaylens.com/de/agb',
  helpUrl: 'https://help.vaylens.com/s/article/Onboarding-a-Home-charger',
  vaylensBackendUrl: 'wss://cposervice.com',
  vaylensBackendUrlWithPort: 'wss://cposervice.com:443',
  googleMapsApiKey: 'AIzaSyAtTh-QRJy2q8VmfLgdR93ZqLS4hzcW2OE',
  googleMapId: '34e6a07ec668dbc1',
  translationCacheServiceUrl:
    'https://translation-cache.prod.services-emobility.com',
  lokaliseProjectId: '30500367685bffa8a78052.69353563',
};
